import { render, staticRenderFns } from "./KoutsuhiPatternForm.vue?vue&type=template&id=5ddb68da&scoped=true&"
import script from "./KoutsuhiPatternForm.vue?vue&type=script&lang=ts&"
export * from "./KoutsuhiPatternForm.vue?vue&type=script&lang=ts&"
import style0 from "./KoutsuhiPatternForm.vue?vue&type=style&index=0&id=5ddb68da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb68da",
  null
  
)

export default component.exports